// react
import React, { useEffect, useState } from 'react';

// components
import { Videos, Sidebar } from './';

// ---
import { fetchFromAPI } from '../utils/fetchFromAPI';

const Feed = () => {
  const [selectedCategory, setSelectedCategory] = useState('New');
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    setVideos([]);

    fetchFromAPI(`search?part=snippet&q=${selectedCategory}`).then((data) => setVideos(data.items));
  }, [selectedCategory]);

  return (
    <div className='grid grid-cols-1 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7'>
      <div className='w-full px-2.5 py-3 bg-black/30'>
        <Sidebar selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} />
      </div>

      <div className='lg:col-span-4 xl:col-span-5 2xl:col-span-6 px-2.5 py-4'>
        <h4 className='flex items-center space-x-3 text-2xl md:text-3xl font-bold'>
          <span>{selectedCategory}</span>
          <span className='py-1 px-2 bg-gray-800 text-lg text-red-600 rounded'>Videos</span>
        </h4>

        <Videos videos={videos} />
      </div>
    </div>
  );
};

export default Feed;
